// extracted by mini-css-extract-plugin
export var numpadContainer = "_qx-1";
export var phoneButton = "_qx-0";